var _title, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUser = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "13px",
    viewBox: "0 0 12 13",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "globe")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M9.59333333,8.39416667 C11.249037,8.39416667 12.59125,9.73637968 12.59125,11.3920833 L12.59125,11.3920833 L12.59125,12.59125 C12.59125,12.9223907 12.3228074,13.1908333 11.9916667,13.1908333 C11.6605259,13.1908333 11.3920833,12.9223907 11.3920833,12.59125 L11.3920833,12.59125 L11.3920833,11.3920833 C11.3920833,10.3986611 10.5867555,9.59333333 9.59333333,9.59333333 L9.59333333,9.59333333 L4.79666667,9.59333333 C3.80324447,9.59333333 2.99791667,10.3986611 2.99791667,11.3920833 L2.99791667,11.3920833 L2.99791667,12.59125 C2.99791667,12.9223907 2.72947406,13.1908333 2.39833333,13.1908333 C2.0671926,13.1908333 1.79875,12.9223907 1.79875,12.59125 L1.79875,12.59125 L1.79875,11.3920833 C1.79875,9.73637968 3.14096301,8.39416667 4.79666667,8.39416667 L4.79666667,8.39416667 Z M7.195,1.19916667 C8.85070366,1.19916667 10.1929167,2.54137968 10.1929167,4.19708333 C10.1929167,5.85278699 8.85070366,7.195 7.195,7.195 C5.53929634,7.195 4.19708333,5.85278699 4.19708333,4.19708333 C4.19708333,2.54137968 5.53929634,1.19916667 7.195,1.19916667 Z M7.195,2.39833333 C6.20157781,2.39833333 5.39625,3.20366114 5.39625,4.19708333 C5.39625,5.19050553 6.20157781,5.99583333 7.195,5.99583333 C8.18842219,5.99583333 8.99375,5.19050553 8.99375,4.19708333 C8.99375,3.20366114 8.18842219,2.39833333 7.195,2.39833333 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BITACore-Resources-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Account-Preferences---A---01",
    transform: "translate(-34.000000, -872.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9",
    transform: "translate(2.000000, 839.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Log-Out-Copy-2",
    transform: "translate(31.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(0.000000, 1.997831)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Combined-Shape",
    fill: "#000000",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "COLOR/-white",
    mask: "url(#mask-2)",
    fill: "#FFFFFF",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 14.39,
    height: 14.39
  })))))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUser, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user.b5050228.svg";
export { ForwardRef as ReactComponent };